import React from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { catalogBibShape, ugcCommentShape, libraryShape } from '@bibliocommons/bc-prop-types';

import ErrorPage from 'app/components/ErrorPage';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCatalogBibEntities, selectCommentEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import RelationshipsActions from 'app/actions/RelationshipsActions';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import CommentPage from './CommentPage';

export function CommentPageContainer(props) {
  const { catalogBib, comment, intl } = props;
  if (!comment) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />;
  }

  const title = catalogBib.getIn(['brief', 'title']);
  const pageTitle = intl.formatMessage({ id: 'comment_page_title' }, { title });

  return (
    <div>
      <DocumentHeadContainer pageTitle={pageTitle} />
      <CommentPage {...props} />
    </div>
  );
}

CommentPageContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  comment: ugcCommentShape,
  currentUserId: PropTypes.number,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentLibrary: libraryShape.isRequired
};

const mapStateToProps = state => {
  const comment = state.getIn(['ugc', 'comment']);
  const commentEntity = selectCommentEntities(state).get(comment.get('id', '').toString());
  if (!commentEntity) return {};

  return {
    catalogBib: selectCatalogBibEntities(state).get(commentEntity.get('metadataId')),
    comment: commentEntity,
    currentUserId: selectCurrentUser(state)?.get('id') ?? null,
    currentLibrary: selectCurrentLibrary(state)
  };
};

const mapDispatchToProps = dispatch => ({
  relationshipsActions: bindActionCreators(RelationshipsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CommentPageContainer));
